import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
// @mui

import { Box, List, Typography } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";

import NavConfig from "./config";
import useResponsive from "../../../hooks/useResponsive";
import { PATH_DASHBOARD } from "../../../routes/path";
// ----------------------------------------------------------------------
const NAV_WIDTH = 250;

// ----------------------------------------------------------------------

interface NavItem {
  title: string;
  path: string;
  icon: React.ReactNode;
}

interface NavSectionProps {
  data: () => NavItem[]; // Define the type of the data prop
}

const NavStyle = styled("div")(({ theme }) => ({
  height: "100vh",
  flexShrink: 0,
  width: NAV_WIDTH,
  padding: "0 22px",
  [theme.breakpoints.up("lg")]: {
    paddingTop: 34,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
}));
const Navigation = () => {
  const isDesktop = useResponsive("down", "lg", "xl");
  const isMedium = useResponsive("down", "md", "xs");
  const navigate = useNavigate();

  return (
    <NavStyle
      sx={{
        position: "fixed",
        display: isDesktop ? "none" : "block",
      }}
    >
      <Box>
        <img
          src="/assets/icons/logo-admin.svg"
          width="195"
          height="46"
          alt=""
          style={{ cursor: "pointer" }}
          onClick={() => navigate(PATH_DASHBOARD.root)}
        />
      </Box>
      <NavSection data={NavConfig} />
    </NavStyle>
  );
};

export default Navigation;

function NavSection({ data }: NavSectionProps) {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();

  const isCurrentPath = (path: string) => {
    return location.pathname.startsWith(path);
  };
  const handlePathNavigate = (path: string) => {
    navigate(path);
  };
  const newData = data();
  return (
    <Box sx={{ marginTop: "1rem" }}>
      <List disablePadding sx={{ p: 1, my: 1 }}>
        {newData.map((item: NavItem) => (
          <Box
            key={item.title}
            onClick={() => handlePathNavigate(item?.path)}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "14px",
              cursor: "pointer",
              my: 2,
              py: 2,
              px: 3,
              background: isCurrentPath(item.path)
                ? theme.palette.primary.main
                : "",
              borderRadius: "10px",
              color: isCurrentPath(item.path)
                ? theme.palette.common.white
                : theme.palette.secondary.contrastText,
            }}
          >
            {item.icon}
            <Typography
              variant="body1"
              sx={{
                fontWeight: isCurrentPath(item.path) ? 700 : 400,
              }}
            >
              {item.title}
            </Typography>
          </Box>
        ))}
      </List>
    </Box>
  );
}
